var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0609 19.4445C5.11921 19.4445 1.10254 15.4278 1.10254 10.4862C1.10254 5.5445 5.11921 1.52783 10.0609 1.52783C15.0025 1.52783 19.0192 5.5445 19.0192 10.4862C19.0192 15.4278 15.0025 19.4445 10.0609 19.4445ZM10.0609 2.77783C5.81087 2.77783 2.35254 6.23617 2.35254 10.4862C2.35254 14.7362 5.81087 18.1945 10.0609 18.1945C14.3109 18.1945 17.7692 14.7362 17.7692 10.4862C17.7692 6.23617 14.3109 2.77783 10.0609 2.77783Z",
    fill: "#D83612"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1524 13.7613C13.0441 13.7613 12.9357 13.7363 12.8357 13.6696L10.2524 12.128C9.61074 11.7446 9.13574 10.903 9.13574 10.1613V6.74463C9.13574 6.40296 9.41908 6.11963 9.76074 6.11963C10.1024 6.11963 10.3857 6.40296 10.3857 6.74463V10.1613C10.3857 10.4613 10.6357 10.903 10.8941 11.053L13.4774 12.5946C13.7774 12.7696 13.8691 13.153 13.6941 13.453C13.5691 13.653 13.3607 13.7613 13.1524 13.7613Z",
    fill: "#D83612"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.a0e86985f87637c6701c6e56c198352c.svg";
export { ForwardRef as ReactComponent };